<template>
    <div id="cart">
        <form-wizard
                ref="checkoutWizard"
                color="rgba(var(--vs-primary), 1)"
                :title="null"
                :subtitle="null"
                :hide-buttons="true">

            <!-- tab 1 content -->
            <div v-if="cart">
                <vs-alert class="mb-3" :active="!cart.kilometers_ok && cart.max_kilometers > 0">
                    Največja razdalja za dostavo je {{cart.max_kilometers}} kilometrov.
                </vs-alert>

                <vs-alert class="mb-3" :active="!cart.min_price_ok && cart.min_price > 0">
                    Minimalo naročilo glede na izbrani naslov je {{cart.min_price}}&euro;.
                </vs-alert>

                <vs-alert class="mb-3" :active="!cart.order_time_ok">
                    {{cart.time_problem}}
                </vs-alert>
            </div>

            <tab-content title="Izdelki" icon="feather icon-shopping-cart" class="mb-5">

                <!-- IF CART HAVE ITEMS -->
                <div class="vx-row" v-if="cartItems && cartItems.length">

                    <!-- LEFT COL -->
                    <div class="vx-col lg:w-2/3 w-full relative">
                        <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.id">
                            <cart-item :item="item" class="mb-base">

                                <!-- SLOT: ITEM META -->
                                <template slot="item-meta">
                                    <h6
                                            class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                                            @click="$router.push('/food/' + item.food_id)">{{ item.food_name }}</h6>

                                    <p class="mt-4 font-bold text-sm">Količina</p>
                                    <vs-input-number min="1" max="10" v-model="item.quantity" @input="setQuantity(item)" class="inline-flex mb-4" />

                                    <p v-for="(optionName, index) in item.option_names" :key="item.id + '-' + index"><b>{{index}}:</b> {{optionName}}</p>

                                    <p v-if="item.additional_comments.length > 0" class="mt-4 text-sm"><b>Dodaten opis: </b>{{item.additional_comments}}</p>
                                </template>

                                <!-- SLOT: ACTION BUTTONS -->
                                <template slot="action-buttons">

                                    <!-- PRIMARY BUTTON: REMOVE -->
                                    <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3" @click="removeItemFromCart(item.id)">
                                        <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                                        <span class="text-sm font-semibold ml-2">ODSTRANI</span>
                                    </div>

                                    <div class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer" @click="openFoodEdit(item)">
                                        <feather-icon icon="EditIcon" svgClasses="h-4 w-4"/>
                                        <span class="text-sm ml-2">Uredi</span>
                                    </div>
                                </template>
                            </cart-item>
                        </div>
                    </div>

                    <!-- RIGHT COL -->
                    <div class="vx-col lg:w-1/3 lg:order-last w-full order-first mb-6">
                        <vx-card v-if="cart">

                            <p class="font-semibold mb-3">Cena</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Jedi</span>
                                <span>{{cart.food_price}}&euro;</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Dostava</span>
                                <span>{{cart.shipping_price}}&euro;</span>
                            </div>

                            <vs-divider />

                            <div class="flex justify-between font-semibold mb-3">
                                <span>Skupno</span>
                                <span>{{cart.total_price}}&euro;</span>
                            </div>

                            <vs-button class="w-full" @click="goToShippingAddress">Izberi naslov</vs-button>
                        </vx-card>
                    </div>
                </div>

                <!-- IF NO ITEMS IN CART -->
                <vx-card title="V vozičku nimate nobenega izdelka!" v-else>
                    <vs-button @click="$router.push('/').catch(() => {})">Domov</vs-button>
                </vx-card>

            </tab-content>

            <!-- tab 2 content -->
            <tab-content title="Nalov" icon="feather icon-home" class="mb-5">

                <div class="vx-row">

                    <div class="vx-col lg:w-2/3 w-full" v-if="addresses">
                        <h3 v-if="addresses.length > 0" class="mb-6">Izberi naslov za dostavo</h3>
                        <h3 v-else class="mb-6">Prosim dodajte naslov za dostavo!</h3>
                        <vs-button class="mb-6" color="primary" @click="addAddressPromptActive = true">Dodaj naslov</vs-button>
                        <ul style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;" class="w-full">
                            <li class="mr-4 w-full" :key="index" v-for="(address, index) in addresses">
                                <vx-card class="mb-base w-full" style="cursor: pointer" @click="selectedAddress = address">
                                    <div class="flex flex-wrap items-center mt-2 w-full">
                                        <vs-radio :vs-name="address.id" v-model="selectedAddress" :vs-value="address"/>

                                        <div class="vx-row w-full">
                                            <div class="vx-col w-1/2">
                                                <div class="ml-4">
                                                    <h5>{{address.title}}</h5>
                                                    <p>{{address.address}}</p>
                                                    <p>{{address.town}}</p>
                                                    <p>{{address.country}}</p>
                                                </div>

                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-button style="float: right" class="mt-6" color="primary" @click="removeAddress(address.id)">Izbriši</vs-button>
                                            </div>
                                        </div>

                                    </div>
                                </vx-card>

                            </li>
                        </ul>
                    </div>



                    <!-- RIGHT COL: CONTINUE WITH SAVED ADDRESS -->
                    <div class="vx-col lg:w-1/3 lg:order-last w-full order-first mb-6" v-if="cart">
                        <vx-card :title="selectedAddress.title">
                            <div>
                                <p>{{selectedAddress.address}}</p>
                                <p>{{selectedAddress.town}}</p>
                                <p>{{selectedAddress.country}}</p>
                            </div>

                            <vs-divider />

                            <vs-button :disabled="!cart.kilometers_ok || !cart.min_price_ok || !selectedAddress.id" class="w-full" @click="goToPayment">Dostavi na ta naslov</vs-button>
                        </vx-card>
                    </div>

                </div>
            </tab-content>

            <!-- tab 3 content -->
            <tab-content title="Plačilo" icon="feather icon-credit-card" class="mb-5">

                <div class="vx-row">

                    <!-- LEFT COL: PAYMENT OPTIONS -->
                    <div class="vx-col lg:w-2/3 w-full">
                        <vx-card title="Vrsta plačila" class="mb-base">

                            <ul style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;" class="w-full">
                                <li class="mr-4 w-full mb-6">
                                    <div class="flex flex-wrap items-center mt-2">
                                        <vs-radio :vs-name="0" v-model="selectedPaymentMethod" :vs-value="0">
                                            <p>Plačilo z kartico ob dostavi</p>
                                        </vs-radio>
                                    </div>
                                </li>
                                <li class="mr-4 w-full mb-6">
                                    <div class="flex flex-wrap items-center mt-2">
                                        <vs-radio :vs-name="1" v-model="selectedPaymentMethod" :vs-value="1">
                                            <p>Plačilo z gotovino ob dostavi</p>
                                        </vs-radio>
                                    </div>
                                </li>
                                <li class="mr-4 w-full">
                                    <div class="flex flex-wrap items-center mt-2 w-full">
                                        <vs-radio :vs-name="2" v-model="selectedPaymentMethod" :vs-value="2" class="w-full">
                                            <p>Spletno plačilo</p>
                                        </vs-radio>
                                        <div class="form-row w-full mt-4" v-show="selectedPaymentMethod === 2">
                                            <label for="card-element">
                                                Kreditna ali debetna kartica
                                            </label>
                                            <div id="card-element">
                                                <!-- A Stripe Element will be inserted here. -->
                                            </div>

                                            <!-- Used to display form errors. -->
                                            <div id="card-errors" role="alert"></div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </vx-card>
                    </div>

                    <!-- RIGHT COL: PRICE -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card title="Cena naročila" v-if="cart">


                            <p class="font-semibold mb-3">Cena</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Jedi</span>
                                <span>{{cart.food_price}}&euro;</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Dostava</span>
                                <span>{{cart.shipping_price}}&euro;</span>
                            </div>

                            <vs-divider />

                            <div class="flex justify-between font-semibold mb-3">
                                <span>Skupno</span>
                                <span>{{cart.total_price}}&euro;</span>
                            </div>

                            <vs-divider/>
                            <vs-alert class="mb-3" :active="showWaitTime">Povprečen čas čakanja je {{waitTime}} minut.</vs-alert>

                            <vs-button :disabled="!cart.kilometers_ok || !cart.min_price_ok || !cart.order_ok || !cart.order_time_ok" class="w-full" @click="pay">Zaključi naročilo</vs-button>
                        </vx-card>
                    </div>
                </div>
            </tab-content>

        </form-wizard>

        <cart-item-edit-prompt v-on:item-updated="updateCartItems()" :item="foodEditItem" ref="cartItemEditRef"/>

        <vs-popup title="Dodaj naslov" :active.sync="addAddressPromptActive">
            <div>
                <p class="mt-6">Ime naslova (lahko vidite samo vi. Primer: Dom, Služba itd..)</p>
                <vs-input v-model="addTitle" style="width: 100%"></vs-input>
                <p class="mt-6">Naslov (Ulica in hišna številka)</p>
                <vs-input v-model="addAddressAddress" style="width: 100%"></vs-input>
                <p class="mt-6">Mesto</p>
                <vs-input v-model="addTown" style="width: 100%"></vs-input>
                <p class="mt-6">Država</p>
                <vs-input v-model="addCountry" style="width: 100%"></vs-input>
                <vs-divider/>
                <h6>Polni naslov (naslov more bit mogoče najt na Google Maps v tej obliki):</h6>
                <p class="mt-6">{{addAddressAddress}}<span v-if="addAddressAddress.length > 0 && addTown.length > 0">,</span> {{addTown}}<span v-if="addTown.length > 0 && addCountry.length > 0">,</span> {{addCountry}}</p>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addAddress">Dodaj</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    import CartItem from "./CartItem";
    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import CartItemEditPrompt from "./CartItemEditPrompt";

    export default {
        components: {
            CartItemEditPrompt,
            CartItem,
            FormWizard,
            TabContent,
        },
        data(){
            return {

                cartItems: [],

                cart: null,

                foodEditItem: {},
                foodEditOpen: false,

                addresses: null,
                updateAddress: false,

                selectedAddress: {},

                selectedPaymentMethod: 0,

                stripeToken: '',

                initialLoaded: false,

                timeUpdateTimer: '',
                waitTime: '',
                showWaitTime: false,

                addAddressPromptActive: false,
                addTitle: '',
                addAddressAddress: '',
                addTown: '',
                addCountry: '',

            }
        },
        methods: {
            updateWaitTime(){
                const thisIns = this;
                this.$http.get('/api/listing/v1/wait_time')
                    .then(function (response) {
                        thisIns.waitTime = response.data;
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            goToPayment(){
                this.$refs.checkoutWizard.nextTab();
                card.mount('#card-element');
                this.showWaitTime = true;
            },
            addAddress(){
                this.$vs.loading();
                const thisIns = this;
                this.$http.post('/api/order/v1/address', {
                    address: this.addAddressAddress,
                    town: this.addTown,
                    country: this.addCountry,
                    title: this.addTitle
                })
                    .then(function () {
                        thisIns.$vs.loading.close();
                        thisIns.addAddressPromptActive = false;
                        thisIns.updateAddresses();
                        thisIns.addAddressAddress = '';
                        thisIns.addTown = '';
                        thisIns.addCountry = '';
                        thisIns.addTitle = '';
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Napaka',
                        text: "Naslov " + thisIns.addAddressAddress + ", " + thisIns.addTown + ", " + thisIns.addCountry + " ni najden v Google Maps!",
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeAddress(id){
                const thisIns = this;
                this.$vs.loading();
                this.$http.delete('/api/order/v1/address/' + id)
                    .then(function () {
                        thisIns.updateAddresses();
                        thisIns.updateCartItems();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: "Napaka",
                        color:'Ni mogoče izbrisat naslova!',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            pay(){

                if(this.selectedPaymentMethod < 2){

                    this.$vs.loading();
                    const thisIns = this;
                    this.$http.post('/api/order/v1/order/finish/')
                        .then(function () {
                            thisIns.$vs.loading.close();
                            thisIns.$vs.notify({
                                title:'Naročilo oddano',
                                color:'success',
                                iconPack: 'feather',
                                icon:'icon-alert-circle'})
                            thisIns.$router.push("/orderConfirmed");
                        }).catch(function (error) {
                        thisIns.$vs.loading.close();
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                }else if(this.selectedPaymentMethod === 2){
                    let thisIns = this;

                    this.$vs.loading();
                    stripe.confirmCardPayment(this.stripeToken, {
                        payment_method: {
                            card: card,
                        }
                    }).then(function(result) {
                        if (result.error) {
                            thisIns.$vs.loading.close();
                            thisIns.$vs.notify({
                                title:'Nakapa pri plačilu',
                                text: result.error.message,
                                color:'danger',
                                iconPack: 'feather',
                                icon:'icon-alert-circle'})
                        } else {
                            thisIns.$http.post('/api/order/v1/order/finish/')
                                .then(function () {
                                    thisIns.$vs.loading.close();
                                    thisIns.$vs.notify({
                                        title:'Plačilo uspešno',
                                        color:'success',
                                        iconPack: 'feather',
                                        icon:'icon-alert-circle'})
                                    thisIns.$router.push("/orderConfirmed");
                                }).catch(function (error) {
                                thisIns.$vs.loading.close();
                                thisIns.$vs.notify({
                                    title:'Error',
                                    text: error,
                                    color:'danger',
                                    iconPack: 'feather',
                                    icon:'icon-alert-circle'})
                            });
                        }
                    });
                }
            },
            goToShippingAddress(){
                if(this.addresses){
                    for(let x = 0; x < this.addresses.length; x++){
                        if(this.addresses[x].id === this.cart.user_address_id){
                            this.selectedAddress = this.addresses[x];
                        }
                    }
                }
                this.$refs.checkoutWizard.nextTab();

            },
            openFoodEdit(obj) {
              this.$refs.cartItemEditRef.openPrompt(obj);
            },
            updateCartItems(){
                this.$vs.loading();
                const thisIns = this;
                this.$http.get('/api/order/v1/cart')
                    .then(function (response) {
                        thisIns.cart = response.data;
                        thisIns.cartItems = thisIns.cart.items;
                        thisIns.stripeToken = thisIns.cart.stripe_token;
                        thisIns.selectedPaymentMethod = thisIns.cart.payment_type;
                        if(thisIns.addresses){
                            for(let x = 0; x < thisIns.addresses.length; x++){
                                if(thisIns.addresses[x].id === thisIns.cart.user_address_id){
                                    thisIns.selectedAddress = thisIns.addresses[x];
                                }
                            }
                        }
                        thisIns.$vs.loading.close();
                        thisIns.$nextTick(() => {
                            thisIns.initialLoaded = true;
                        });

                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close();
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            updateAddresses(){
                const thisIns = this;
                this.$http.get('/api/order/v1/address')
                    .then(function (response) {
                        thisIns.addresses = response.data;
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeItemFromCart(id){
                this.$vs.loading();
                const thisIns = this;
                this.$http.delete('/api/order/v1/cart/' + id)
                    .then(function () {
                        thisIns.updateCartItems();
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close();
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            setQuantity(item){
                const thisIns = this;
                this.$vs.loading();
                this.$http.put('/api/order/v1/cart/' + item.id + '/quantity/' + item.quantity)
                    .then(function () {
                        thisIns.updateCartItems();
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close();
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            }
        },
        watch: {
            selectedAddress(){
                if(!this.initialLoaded) return;
                this.$vs.loading();
                const thisIns = this;
                this.$http.post('/api/order/v1/cart/shipping_address/' + this.selectedAddress.id)
                    .then(function () {
                        thisIns.updateCartItems();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            selectedPaymentMethod(){
                if(!this.initialLoaded) return;
                this.$vs.loading();
                const thisIns = this;
                this.$http.post('/api/order/v1/cart/payment_type/' + this.selectedPaymentMethod)
                    .then(function () {
                        thisIns.updateCartItems();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        beforeDestroy(){
            clearInterval(this.timeUpdateTimer);
        },
        created() {
            this.updateCartItems();
            this.updateAddresses();
            this.updateWaitTime();
            this.timeUpdateTimer = setInterval(()=>{ this.updateWaitTime() }, 5000);
        },
    }

    var stripe = Stripe('pk_live_S4rwAhJnQ5o4Kw36CsF98VUr00Kp4irBdw');
    var elements = stripe.elements();
    var style = {
        base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
        }
    };

    var card = elements.create('card', {style: style});
    card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

</script>

<style lang="scss" scoped>
    .StripeElement {
        box-sizing: border-box;

        height: 40px;

        padding: 10px 12px;

        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;

        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }

    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    #cart {
        .item-view-primary-action-btn {
            color: #2c2c2c !important;
            background-color: #f6f6f6;
        }

        .item-name {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
        }

        .vue-form-wizard {
            padding-bottom: 0;

            ::v-deep .wizard-header {
                padding: 0;
            }

            ::v-deep .wizard-tab-content {
                padding-right: 0;
                padding-left: 0;
                padding-bottom: 0;

                .wizard-tab-container{
                    margin-bottom: 0 !important;
                }
            }
        }
    }
</style>
